<div class="sales-advisor-container">
  <div class="row">
    <div class="header col-md-12">
      <div class="row">
        <div class="header col-md-10">
        <div class="title col-md-10">
          {{'servicePersonnel.salesAdvisors'| translate}}
        </div>
        <div class="warning-msg" *ngIf="(activeEmployees$ | async)?.length < 1 && !(isLoading$ | async) ">
          <div><span class="material-icons" >info</span></div>
          <div>{{'navigation.pleaseMakeSalesAdvisorsOnline' | translate }}</div>
      </div>
      </div>
        <div class='action col-md-2' style="text-align: left;">
          <div *ngIf="(isSyncStatusLoading$|async); else updateBtn">
            <app-loading class="staff-master-sync-loading"
                         loadingSymbol="dots"
                         [text]="'servicePersonnel.loadingSyncStatus' | translate"
                         size=".8"
                         color="var(--dashboard-primary-color)">
            </app-loading>
          </div>
          <ng-template #updateBtn>
            <button class='refresh' (click)='triggerStaffMasterSync()'
                  [disabled]="(syncStatus$ | async) === 'SYNC_IN_PROGRESS'"
                  [ngClass]="(syncStatus$ | async) === 'SYNC_IN_PROGRESS' ? 'disabled': ''">
            <ng-container *ngIf="(syncStatus$ | async) === 'SYNC_IN_PROGRESS'; else salesSyncLabel">
              <app-loading loadingSymbol="dots" [text]="'servicePersonnel.syncInProgress' | translate" color="var(--primary-toyota-color)" size=".55" [compact]="true"></app-loading>
            </ng-container>
            <ng-template #salesSyncLabel>
              <asp-icon class="icon" name="ic-20-utility-update-small.svg" width="1.2rem" height='1.2rem' color='var(--primary-toyota-color)'>
              </asp-icon>
              <span class="sync-text-test">{{'servicePersonnel.updateFromStaffMaster'| translate}}</span>
            </ng-template>
            </button>
            <div class="sync-text">
              <asp-icon class="icon d-inline-block" name="ic-20-utility-time-clock.svg" width="1.2rem" height='1.2rem'
                        color='var(--primary-toyota-color)'>
              </asp-icon>
              <span>{{(lastSyncedAt$ | async) || '' }}</span>
            </div>
          </ng-template>
        </div>
      </div>
    </div>
  </div>
  <div class="row">
    <div class="col-md-12 list-header">
      {{'servicePersonnel.onlineConsultants'| translate}} ({{(activeEmployees$ | async)?.length}})
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <app-employee-list [employees]="(activeEmployees$ | async)"></app-employee-list>
    </div>
  </div>

  <div class="row">
    <div class="col-md-12 list-header">
      {{'servicePersonnel.offlineConsultants'| translate}} ({{(inActiveEmployees$ | async)?.length}})
    </div>
  </div>
  <div class="row">
    <div class="col-md-12">
      <app-employee-list [employees]="(inActiveEmployees$ | async)"></app-employee-list>
    </div>
  </div>
</div>
